import { createContext, type Dispatch } from 'react';
import type { BuilderAction, BuilderState } from '../types';

/**
 * Valore del Context del builder. Definito in un file separato dal Provider
 * per non confliggere con `react-refresh/only-export-components`: il file
 * con il `<BuilderProvider>` esporta solo componenti, mentre la `createContext`
 * (che produce un valore non-componente) vive qui.
 */
export interface BuilderContextValue {
  state: BuilderState;
  dispatch: Dispatch<BuilderAction>;
  /** Cancella il draft persistito e resetta lo stato a uno nuovo. */
  resetBuilder: () => void;
}

export const BuilderContext = createContext<BuilderContextValue | null>(null);
